import { render, staticRenderFns } from "./SideBossButtons.vue?vue&type=template&id=066739d5&"
import script from "./SideBossButtons.vue?vue&type=script&lang=ts&"
export * from "./SideBossButtons.vue?vue&type=script&lang=ts&"
import style0 from "./SideBossButtons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports